import addUserHighlight from '../actions/addUserHighlight';
import removeUserHighlight from '../actions/removeUserHighlight';
import { observer } from 'mobx-react-lite';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { MailIcons } from 'owa-mail-icons';
import { ClientItem } from 'owa-mail-store';
import React from 'react';
import {
    UserMarkup_addHighlight,
    UserMarkup_removeHighlight,
} from './UserMarkupPopup.locstring.json';

const styles = require('./UserMarkupPopup.scss');

export interface HighlightOptionProps {
    selectedText: string;
    element: HTMLElement;
    item: ClientItem;
    isForExistingUserHighlight: boolean;
    destroyPopupDivCallback: () => void;
}

const HighlightOption = observer(function HighlightOption(props: HighlightOptionProps) {
    const {
        selectedText,
        element,
        item,
        isForExistingUserHighlight,
        destroyPopupDivCallback,
    } = props;

    function clearSelection() {
        window.getSelection().removeAllRanges();
    }

    const onAddHighlight = React.useCallback(() => {
        addUserHighlight(element, item, selectedText);
        clearSelection();
        destroyPopupDivCallback();
    }, [selectedText, element, item, destroyPopupDivCallback]);

    const onRemoveHighlight = React.useCallback(() => {
        removeUserHighlight(element, item);
        destroyPopupDivCallback();
    }, [element, item, destroyPopupDivCallback]);

    const highlightButtonProps = isForExistingUserHighlight
        ? {
              iconProps: { iconName: ControlIcons.Delete },
              onClick: onRemoveHighlight,
          }
        : {
              iconProps: { iconName: MailIcons.Highlight },
              onClick: onAddHighlight,
          };

    return (
        <TooltipHost
            hostClassName={styles.userHighlightButtonWrapper}
            content={
                isForExistingUserHighlight
                    ? loc(UserMarkup_removeHighlight)
                    : loc(UserMarkup_addHighlight)
            }>
            <IconButton className={styles.UserMarkupPopupButton} {...highlightButtonProps} />
        </TooltipHost>
    );
});

export default HighlightOption;
